import { OrderedMap } from 'immutable';
import { createSelector } from 'reselect';

import { GlobalStore, key } from './store';

const selectStore = (state: GlobalStore) => state[key];

export const makeSelectObjects = (instanceId: string) =>
	createSelector(
		selectStore,
		(store) =>
			store.getIn(['instances', instanceId, 'objects']) || OrderedMap()
	);

export const makeSelectObjectsArray = (instanceId: string) =>
	createSelector(makeSelectObjects(instanceId), (objects) =>
		objects.toList().toJS()
	);

export const makeSelectInProgress = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'inProgress'])
	);

export const makeSelectPaginationInProgress = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'paginationInProgress'])
	);

export const makeSelectError = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'error'])
	);

export const makeSelectCount = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'count'])
	);

export const makeSelectGlobalCount = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'globalCount'])
	);

export const makeSelectOffset = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'offset'])
	);

export const makeSelectPaginate = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'pagination'])
	);

export const makeSelectSearchStr = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'searchStr'])
	);

export const makeSelectSearchTerm = (instanceId: string) =>
	createSelector(selectStore, (store) =>
		store.getIn(['instances', instanceId, 'searchTerm'])
	);

export const makeSelectFilters = (instanceId: string) =>
	createSelector(
		selectStore,
		(store) => store.getIn(['instances', instanceId, 'filters']) || {}
	);

export const makeSelectFilter = (instanceId: string, filterName: string) =>
	createSelector(
		makeSelectFilters(instanceId),
		(filters) => filters[filterName]
	);

export const makeSelectOrderings = (instanceId: string) =>
	createSelector(
		selectStore,
		(store) => store.getIn(['instances', instanceId, 'orderings']) || []
	);

export const makeSelectSort = (instanceId: string) =>
	createSelector(
		selectStore,
		(store) => store.getIn(['instances', instanceId, 'sort']) || []
	);

export const makeSelectRequestParams = (instanceId: string) =>
	createSelector(
		selectStore,
		(store) => store.getIn(['instances', instanceId, 'requestParams']) || []
	);

export const makeSelectProperty = (instanceId: string) =>
	createSelector(
		selectStore,
		(store) => store.getIn(['instances', instanceId, 'property']) || []
	);

export const makeSelectCancelToken = (instanceId: string) =>
	createSelector(
		selectStore,
		(store) => store.getIn(['instances', instanceId, 'cancelToken']) || null
	)
export const makeSelectLimit = (instanceId: string) =>
createSelector(
	selectStore,
	(store) => store.getIn(['instances', instanceId, 'limit']) || null
);